/**
 * Removes focus from the currently active element.
 *
 * Primarily used before major UI transitions (dialogs, tabs,
 * fullscreen changes, navigation) to ensure virtual keyboards
 * on Android tablets are dismissed cleanly and do not cause
 * viewport rendering issues.
 */
export function blurActiveElement(): void {
  if (document.activeElement instanceof HTMLElement) {
    document.activeElement.blur();
  }
}